
export const locationService = (function () {
  const publicAPIs = {};
  publicAPIs.getLocation = async () => {
    // const position = await this.getCoordinates(); 
    // let geoLocation = new GeoLocation();
    let promise = new Promise((resolve , reject)=>{
      navigator.geolocation.getCurrentPosition((position) =>{
       resolve(position);
   
       }
      ,()=>{
        if(localStorage.getItem('userLocale') ==='fa-IR'){
          reject({response:{data:{Message:"در فرایند دریافت موقعیت مکانی شما مشکلی وجود دارد لطفا با پشتیبانی تماس بگیرید"}}});
        }else{
          reject({response:{data:{Message:"There is been a problem getting you're location please contact support"}}});
        }
      })

      
      // const location={
      //   coords:{
      //     latitude:33.625713577302534,
      //     longitude:51.624605382845374
      //   }
      // }
      // resolve(location);
    })
    return promise;
  }


  // Return our public methods so that they can be accessed
  return publicAPIs;

})();
